import { DialogContent } from '@material-ui/core';
import { Spinner, Typography } from '@catapultsports/referee-react';
import { RadioButton } from '../../../../reporting/components/radio-button/radio-button';
import { FocusTable } from '../../../../focus/component/focus-table/focus-table';
import { useState } from 'react';
import { useFocusImport } from '../use-focus-import';
import { useGetDeepActivity } from 'api';
import styles from '../focus-import.module.css';

export const AlignPeriodsScreen = () => {
    const { activityId, focusFile } = useFocusImport();
    const { data, isLoading } = useGetDeepActivity(activityId);

    const [selectedOption, setSelectedOption] = useState('');
    const [tableOptions, setTableOptions] = useState<string[]>([]);

    if (isLoading) {
        return (
            <DialogContent>
                <Spinner />
            </DialogContent>
        );
    }

    return (
        <DialogContent>
            <div className={styles['start-page-body']}>
                <div>
                    <Typography variant="heading-2">Align your Focus Import with Openfield Periods</Typography>
                    <Typography variant="heading-5">step 1 of 3</Typography>
                </div>
                <div>
                    <RadioButton
                        label={'timing tag'}
                        onChange={(event) => {
                            setTableOptions(focusFile?.timing.map((t) => t.period_id) ?? []);
                            setSelectedOption(event.target.value);
                        }}
                        value={'timing'}
                        isChecked={selectedOption === 'timing'}
                        name={'period_align'}
                        disabled={focusFile?.timing?.length === 0 ?? true}
                    />
                    <RadioButton
                        label={'Focus Tag'}
                        onChange={(event) => {
                            setTableOptions([]);
                            setSelectedOption(event.target.value);
                        }}
                        value={'tag'}
                        isChecked={selectedOption === 'tag'}
                        name={'period_align'}
                        disabled={false}
                    />
                </div>
                <FocusTable periods={data?.[0]?.periods ?? []} syncToFocusOptions={tableOptions} />
            </div>
        </DialogContent>
    );
};
